import { useEffect, useState } from "react";
import "./loading.scss";

const Loading = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Start loading when component mounts
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 0.8); // Completes in 3 seconds (100 steps * 30ms)

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="afterlogin-animation">
        <div className="afterloginbox">
          <div className="af-circle">
            <div className="aflock">
               <img  loading="lazy" src="/images/adminlock.svg" alt="icon" />
            </div>
          </div>
          <div className="afhead">Admin Portal</div>
          <div className="aftitle">Management System</div>
          <div className="progress-bar-container">
            <div className="progress-bar" style={{ width: `${progress}%` }} />
            {/* <div className="percentage-text">{progress}%</div> */}
          </div>
          <div className="loading-text">
            Loading... <span className="percent">{progress}</span>%
          </div>
        </div>
      </div>
    </>
  );
};

export default Loading;
